module.exports = __webpack_public_path__ + "img/Map-icon.b4e97361.svg";